import React from "react";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import DataConnectionTable from "./view/DataConnectionTable";

interface DataConProps {}
export const DataConnection: React.FC<DataConProps> = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_securityconfiguration_dataconnection_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <> {userPermissions.includes(viewPermission) && <DataConnectionTable />} </>
  );
};
export default DataConnection;
